/*
  Ivy Pillow — kussenwijzer als multi-step form (bouwplan §7.6).
  Eén vraag per stap, autodoorloop na een keuze, terugknop en voortgang.
  Uitkomstlogica uit het plan: Nube bij "zacht, wegzakkend gevoel", anders
  Brisa bij overwegend zijslapen of "te laag", anders Cala. Het advies
  verschijnt in een aria-live-regio; Opnieuw beginnen reset alles.
*/
(() => {
  const NAMEN = { cala: 'Cala', brisa: 'Brisa', nube: 'Nube' };
  const TWEEDE = { cala: 'brisa', brisa: 'cala', nube: 'cala' };
  const VELDEN = ['slaaphouding', 'voorkeur', 'huidig'];

  function initIvyKussenwijzer(scope) {
    const bereik = scope && scope.querySelectorAll ? scope : document;
    bereik.querySelectorAll('.ivy-kussenwijzer').forEach((sectie) => {
      if (sectie.dataset.ivyInit === 'true') return;
      sectie.dataset.ivyInit = 'true';

      const vorm = sectie.querySelector('.ivy-kussenwijzer__vragen');
      const stappen = Array.from(sectie.querySelectorAll('[data-wijzer-vraag]'));
      const resultaatvlak = sectie.querySelector('[data-wijzer-resultaatvlak]');
      const adviezen = Array.from(sectie.querySelectorAll('[data-wijzer-resultaat]'));
      const terug = sectie.querySelector('[data-wijzer-terug]');
      const label = sectie.querySelector('[data-wijzer-label]');
      const balk = sectie.querySelector('[data-wijzer-balk]');
      const opnieuw = sectie.querySelector('[data-wijzer-opnieuw]');
      if (!vorm || stappen.length < 3 || !resultaatvlak) return;

      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const vlak = sectie.querySelector('.ivy-kussenwijzer__vlak');
      let huidige = 0;

      // Laat het vlak soepel meegroeien of -krimpen met de nieuwe inhoud
      const metSoepeleHoogte = (werk) => {
        if (reduce || !vlak) {
          werk();
          return;
        }
        const start = vlak.offsetHeight;
        werk();
        const eind = vlak.offsetHeight;
        if (Math.abs(start - eind) < 2) return;
        vlak.style.height = `${start}px`;
        void vlak.offsetHeight;
        vlak.classList.add('ivy-kussenwijzer__vlak--animeert');
        vlak.style.height = `${eind}px`;
        const klaar = (e) => {
          if (e && e.propertyName !== 'height') return;
          vlak.classList.remove('ivy-kussenwijzer__vlak--animeert');
          vlak.style.height = '';
          vlak.removeEventListener('transitionend', klaar);
          clearTimeout(vangnet);
        };
        vlak.addEventListener('transitionend', klaar);
        const vangnet = setTimeout(klaar, 550);
      };

      const toonStap = (index, focus) => {
        huidige = index;
        resultaatvlak.hidden = true;
        stappen.forEach((stap, i) => {
          stap.hidden = i !== index;
          stap.classList.toggle('ivy-kussenwijzer__stap--actief', i === index);
        });
        if (terug) terug.hidden = index === 0;
        if (label) label.textContent = `Vraag ${index + 1} van ${stappen.length}`;
        if (balk) balk.style.width = `${((index + 1) / (stappen.length + 1)) * 100}%`;
        if (focus) {
          const legende = stappen[index].querySelector('.ivy-kussenwijzer__legende');
          if (legende) legende.focus();
        }
      };

      const lees = (naam) => {
        const gekozen = vorm.querySelector(`input[name="${naam}"]:checked`);
        return gekozen ? gekozen.value : null;
      };

      const toonResultaat = () => {
        const voorkeur = lees('voorkeur');
        const slaaphouding = lees('slaaphouding');
        const huidig = lees('huidig');
        let uitkomst = 'cala';
        if (voorkeur === 'zacht') uitkomst = 'nube';
        else if (slaaphouding === 'zij' || huidig === 'te-laag') uitkomst = 'brisa';

        stappen.forEach((stap) => {
          stap.hidden = true;
          stap.classList.remove('ivy-kussenwijzer__stap--actief');
        });
        if (terug) terug.hidden = false;
        if (label) label.textContent = 'Jouw advies';
        if (balk) balk.style.width = '100%';

        adviezen.forEach((advies) => {
          const past = advies.dataset.wijzerResultaat === uitkomst;
          advies.hidden = !past;
          if (past) {
            const tweedeEl = advies.querySelector('[data-wijzer-tweede]');
            const tweede = TWEEDE[uitkomst];
            const tweedeAdvies = adviezen.find((el) => el.dataset.wijzerResultaat === tweede);
            if (tweedeEl && tweedeAdvies) {
              const link = tweedeAdvies.querySelector('.ivy-kaart__info');
              const url = link ? link.getAttribute('href') : null;
              tweedeEl.innerHTML = url
                ? `Twijfel je nog? Dan past ook <a href="${url}">${NAMEN[tweede]}</a>.`
                : '';
            }
          }
        });
        resultaatvlak.hidden = false;
      };

      vorm.addEventListener('change', (e) => {
        const veld = e.target.name;
        const index = VELDEN.indexOf(veld);
        if (index === -1 || index !== huidige) return;
        const wacht = reduce ? 0 : 220;
        setTimeout(() => {
          metSoepeleHoogte(() => {
            if (huidige < stappen.length - 1) {
              toonStap(huidige + 1, true);
            } else {
              toonResultaat();
            }
          });
        }, wacht);
      });

      if (terug) {
        terug.addEventListener('click', () => {
          metSoepeleHoogte(() => {
            if (!resultaatvlak.hidden) {
              toonStap(stappen.length - 1, true);
            } else if (huidige > 0) {
              toonStap(huidige - 1, true);
            }
          });
        });
      }

      if (opnieuw) {
        opnieuw.addEventListener('click', () => {
          metSoepeleHoogte(() => {
            vorm.reset();
            toonStap(0, true);
          });
        });
      }

      toonStap(0, false);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initIvyKussenwijzer(document));
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => initIvyKussenwijzer(e.target));
  }
})();
